import {playSplitText, playFade, showMagnetBtn} from '../common/help_functions';


export function initMissionSection(element) {
    playFade('.mission-subtitle')
    playSplitText('.mission-title', true)
    playFade('.mission-p')
    showMagnetBtn('.mission-btn')
}
